export interface PaperworkSelection {
  employmentEligibilityDocs: string[];
  hiringAgreements: string[];
  taxDocs: string[];
  otherDocs: string[];
  i9Option: string;
}

const toList = (value: any): string[] =>
  Array.isArray(value) ? value.map((item: any) => String(item ?? '').trim()).filter((item: string) => item !== '') : [];

export const isI9Key = (key: string) =>
  String(key ?? '')
    .toUpperCase()
    .startsWith('I9');

export const buildPaperworkSelection = (employee: any): PaperworkSelection => {
  const employmentEligibilityDocs = toList(employee?.employmentEligibilityDocs);

  return {
    employmentEligibilityDocs,
    hiringAgreements: toList(employee?.hiringAgreements),
    taxDocs: toList(employee?.taxDocs),
    otherDocs: toList(employee?.otherDocs),
    i9Option: employmentEligibilityDocs.find(isI9Key) || '',
  };
};

export const buildLockedKeys = (employee: any): string[] => {
  const selection = buildPaperworkSelection(employee);

  return [
    ...selection.employmentEligibilityDocs,
    ...selection.hiringAgreements,
    ...selection.taxDocs,
    ...selection.otherDocs,
  ];
};

export const buildResendPaperworkPayload = (
  selection: PaperworkSelection,
  reason: string,
  onlyRequestedDocuments = false,
) => {
  const employmentEligibilityDocs = [...selection.employmentEligibilityDocs];

  if (selection.i9Option && !employmentEligibilityDocs.some(isI9Key)) {
    employmentEligibilityDocs.push(selection.i9Option);
  }

  return {
    reason,
    employmentEligibilityDocs,
    hiringAgreements: selection.hiringAgreements,
    taxDocs: selection.taxDocs,
    otherDocs: selection.otherDocs,
    onlyRequestedDocuments,
  };
};
